import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import { ImpRotatingChevron } from '../../Atoms/ImpRotatingChevron/ImpRotatingChevron';
import ImpSpacer from '../../Atoms/ImpSpacer/ImpSpacer';
import { colors } from '../../DesignSystem/colors';
import { ACCORDION_ANIMATION_DURATION } from '../../DesignSystem/design-system';
import { Icons } from '../../Icons/Icons';
import ImpBadgeText from '../ImpBadgeText/ImpBadgeText';
import ImpDivider from '../ImpDivider/ImpDivider';
import ImpIcon from '../ImpIcon/ImpIcon';
import ImpText from '../ImpText/ImpText';
const StyledContent = styled.div `
  height: ${({ open, maxHeight }) => (open ? `${maxHeight}px` : '0')};
  opacity: ${({ open, staticOpen }) => (open || staticOpen ? 1 : 0)};
  overflow: hidden;
  ${({ staticOpen }) => !staticOpen &&
    `transition: height ${ACCORDION_ANIMATION_DURATION} ease,
    opacity ${ACCORDION_ANIMATION_DURATION} ease,
    transform ${ACCORDION_ANIMATION_DURATION} ease`};
  width: 100%;
`;
const ContentContainer = ({ open, content, staticOpen, }) => {
    const contentRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState(0);
    useEffect(() => {
        const updateMaxHeight = () => {
            if (contentRef.current) {
                setMaxHeight(open ? contentRef.current.scrollHeight : 0);
            }
        };
        updateMaxHeight();
        window.addEventListener('resize', updateMaxHeight);
        return () => window.removeEventListener('resize', updateMaxHeight);
    }, [open, content]);
    return (React.createElement(StyledContent, { staticOpen: staticOpen, open: open, maxHeight: maxHeight, ref: contentRef },
        React.createElement(ImpDivider, { color: colors.border.borderVariant }),
        React.createElement(ImpSpacer, { height: "l" }),
        content,
        React.createElement(ImpSpacer, { height: "l" })));
};
export const useChevron = (open) => {
    const [chevronAnimation, setChevronAnimation] = useState('none');
    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            setChevronAnimation(open ? 'forward' : 'backward');
        }
    }, [open]);
    return chevronAnimation;
};
export default function ImpAccordionItem({ open = false, title, subtitle, dividerBottom, content, badge, staticOpen, onClick, }) {
    const chevronAnimation = useChevron(open);
    return (React.createElement(ImpContainer, { width: "100%", onClick: onClick },
        React.createElement(ImpPad, { fluid: true, padding: "0 16px" },
            React.createElement(ImpFlex, { direction: "column", fluid: true },
                React.createElement(ImpFlex, { direction: "row", justify: "space-between", align: "center", fluid: true },
                    React.createElement(ImpContainer, { width: "100%" },
                        React.createElement(ImpPad, { fluid: true, padding: "16px 0" },
                            React.createElement(ImpFlex, { direction: "column", gap: "s" },
                                badge && React.createElement(ImpBadgeText, { ...badge }),
                                React.createElement(ImpFlex, { direction: "row", justify: "space-between", align: "center", fluid: true },
                                    React.createElement(ImpFlex, { direction: "column", align: "flex-start", gap: "xs" },
                                        subtitle && (React.createElement(ImpText, { typography: "headline1", handleSuperscript: true }, subtitle)),
                                        title && (React.createElement(ImpText, { typography: "label1", color: colors.content.onSurfaceVariant, handleSuperscript: true }, title))),
                                    content && onClick && (React.createElement(ImpRotatingChevron, { chevronAnimation: chevronAnimation, rotationDuration: ACCORDION_ANIMATION_DURATION },
                                        React.createElement(ImpIcon, { size: "24px", stroke: colors.content.onBackgroundVariant, iconSrc: Icons.chevronDown })))))))),
                content && (React.createElement(ContentContainer, { staticOpen: staticOpen, open: open, content: content })))),
        dividerBottom && React.createElement(ImpDivider, { color: colors.border.borderVariant })));
}
//# sourceMappingURL=ImpAccordionItem.js.map